export default {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  THUMBS_UP: '👍',
  THUMBS_DOWN: '👎'
}
